/*
  h26-bun.js: behaviour for the Harvest 2026 bundle page (sections/h26-bun-main.liquid).
  Works on top of assets/h26-pdp.js (gallery zoom, carousels + oo_carousel_move, farmer
  Read more on the one-farmer card, sticky bar, Notify, the policy jump), which the section
  also loads. Idempotent; never throws to the page. Add to cart is assets/h26-atc.js.
  - gallery dots (no side thumbnails on bundles), synced with swipe
  - shelf buttons + range strip: scroll to that item's What's inside card and highlight it
    (the shelf never opens the zoom)
  - View all: carousel <-> grid
  - in-page panels: Full details, farmer story, label story. One panel per module; the trigger
    gets aria-expanded; Close / Escape / the same trigger close it and focus returns.
    The click event (oo_full_details_open, oo_farmer_panel_open) fires on open only.
  - Read all reviews: opens Judge.me's own widget for this set in the page
  - jumps: rating -> reviews (opens the widget when there are no curated cards), Meet the farmers
  - pre-order line: after the market's cutoff (Ship window record) shows the record's
    after_cutoff_line instead of the promise line (cached pages re-checked in the browser)
  - set picker (Oct 16, PICKER-SPEC.md): rows replace the pills; on phones the list closes to the picked row
    plus a toggle (data-h26b-pick-toggle); its open state survives the variant swap below.
  - variant picker (Oct 13, bundles with several variants): sets ?variant= in the URL, fetches
    this section and the sticky bar for that variant (Section Rendering API, same URL, so a
    preview_theme_id stays) and swaps both in; every module re-renders server-side. Judge.me's
    widget node is carried over (reviews are per product). Then h26-pdp.js and this file re-init,
    Shop Pay re-inits. On a failed fetch the page simply loads the variant URL.
    oo_variant_select {from, to} fires from the button's data-h26-event.
  Events go through assets/h26-events.js (data-h26-event on the controls).
*/
(function () {
  'use strict';
  if (window.__h26bun) return;
  window.__h26bun = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var beh = reduce ? 'auto' : 'smooth';
  function scrollToEl(el, off) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - (off == null ? 90 : off);
    window.scrollTo({ top: Math.max(0, top), behavior: beh });
  }

  /* ---------- gallery dots ---------- */
  function initDots(root) {
    $$('[data-h26b-dots]', root).forEach(function (d) {
      if (d.__h26) return; d.__h26 = true;
      var g = d.closest('[data-h26-gallery]');
      var t = g && $('[data-h26-track]', g);
      if (!t) return;
      var n = t.children.length;
      var lab = d.getAttribute('data-label') || '{n}';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', lab.replace('{n}', String(i + 1)));
        b.setAttribute('aria-current', String(i === 0));
        (function (k) { b.addEventListener('click', function () { t.scrollTo({ left: t.clientWidth * k, behavior: beh }); }); })(i);
        d.appendChild(b);
      }
      var cur = 0;
      t.addEventListener('scroll', function () {
        var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        if (i === cur) return; cur = i;
        $$('button', d).forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); });
      }, { passive: true });
    });
  }

  /* ---------- shelf + range strip -> card ---------- */
  function goTo(id) {
    var card = document.getElementById('h26b-wi-' + id);
    if (!card) return;
    $$('.h26b-wi.is-hl').forEach(function (x) { x.classList.remove('is-hl'); });
    card.classList.add('is-hl');
    var sec = document.getElementById('h26b-inside');
    scrollToEl(sec || card, 70);
    var tr = card.closest('[data-h26-track-car]');
    if (tr && !tr.classList.contains('is-all')) tr.scrollTo({ left: card.offsetLeft - tr.offsetLeft, behavior: beh });
  }

  /* ---------- panels ---------- */
  var OPEN = {};   // panel kind -> { panel, trigger, attr }
  var KINDS = { fd: 'data-h26b-fd', fp: 'data-h26b-fp', ap: 'data-h26b-ap' };
  function closePanel(kind, refocus) {
    var o = OPEN[kind];
    if (!o) return;
    o.panel.hidden = true;
    $('[data-h26b-panel-body]', o.panel).innerHTML = '';
    o.trigger.setAttribute('aria-expanded', 'false');
    if (o.ev) o.trigger.setAttribute('data-h26-event', o.ev);
    if (kind === 'fd') $$('.h26b-wi.is-hl').forEach(function (x) { x.classList.remove('is-hl'); });
    delete OPEN[kind];
    if (refocus && o.trigger.focus) o.trigger.focus({ preventScroll: false });
  }
  function openPanel(kind, trigger) {
    var key = trigger.getAttribute(KINDS[kind]);
    var sec = trigger.closest('.h26b-sec') || document;
    var panel = $('[data-h26b-panel="' + kind + '"]', sec);
    var tpl = $('template[' + KINDS[kind] + '-tpl="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]', sec);
    if (!panel || !tpl) return;
    if (OPEN[kind] && OPEN[kind].trigger === trigger) { closePanel(kind, true); return; }
    if (OPEN[kind]) closePanel(kind, false);
    var body = $('[data-h26b-panel-body]', panel);
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    panel.hidden = false;
    panel.setAttribute('tabindex', '-1');
    trigger.setAttribute('aria-expanded', 'true');
    var ev = trigger.getAttribute('data-h26-event');
    // the open event has already been published by the click delegation; drop it while open
    setTimeout(function () { if (OPEN[kind] && OPEN[kind].trigger === trigger) trigger.removeAttribute('data-h26-event'); }, 0);
    OPEN[kind] = { panel: panel, trigger: trigger, ev: ev };
    if (kind === 'fd') {
      $$('.h26b-wi.is-hl').forEach(function (x) { x.classList.remove('is-hl'); });
      var card = trigger.closest('.h26b-wi'); if (card) card.classList.add('is-hl');
    }
    try { panel.scrollIntoView({ block: 'nearest', behavior: beh }); } catch (e) {}
    panel.focus({ preventScroll: true });
  }

  /* ---------- variant picker: re-render the section for the chosen variant ---------- */
  var vSeq = 0;
  function sectionId(el) {
    var w = el && el.closest && el.closest('.shopify-section');
    return w && w.id ? w.id.replace(/^shopify-section-/, '') : '';
  }
  function swapIn(old, html, sel) {
    var nu = html ? new DOMParser().parseFromString(html, 'text/html').querySelector(sel) : null;
    if (!old || !nu) throw new Error('no ' + sel);
    nu = document.adoptNode(nu);
    var oldNat = $('[data-h26-reviews-native]', old), newNat = $('[data-h26-reviews-native]', nu);
    if (oldNat && newNat) newNat.parentNode.replaceChild(oldNat, newNat);
    old.parentNode.replaceChild(nu, old);
    return nu;
  }
  function selectVariant(btn) {
    var id = btn.getAttribute('data-h26b-variant');
    var main = document.getElementById('h26p-main');
    if (!id || !main || btn.getAttribute('aria-pressed') === 'true') return;
    var bar = $('[data-h26-sticky]');
    var ids = [sectionId(main), sectionId(bar)].filter(Boolean);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    try { history.replaceState(history.state, '', url.toString()); } catch (e) {}
    $$('[data-h26b-variant]', main).forEach(function (x) { x.setAttribute('aria-pressed', String(x === btn)); });
    main.setAttribute('aria-busy', 'true');
    // Review GPT-1-01: the buy forms point at the picked size at once, and buying is held (aria-busy:
    // CSS blocks taps, guardBusy blocks Enter) until the picked size's sections are swapped in.
    $$('form[data-h26-atc] input[name="id"]', main).forEach(function (i) { if (!i.closest('[data-h26-card]')) i.value = id; });
    if (bar) { bar.setAttribute('aria-busy', 'true'); $$('form[data-h26-atc] input[name="id"]', bar).forEach(function (i) { i.value = id; }); }
    var seq = ++vSeq;
    var req = new URL(url.toString());
    req.searchParams.set('sections', ids.join(','));
    // no Accept: application/json header: with it Shopify answers with the product JSON, not the sections
    fetch(req.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (j) {
        if (seq !== vSeq) return;
        for (var k in OPEN) delete OPEN[k];
        var wasOpen = !!$('[data-h26b-pick].is-open', main);
        var nm = swapIn(main, j[ids[0]], '#h26p-main');
        if (wasOpen) setPickOpen($('[data-h26b-pick]', nm), true);
        // Review GPT-1-01 round 2: a sticky bar that can't be swapped would keep the old size's price with the
        // new size's id, so the page reloads on the picked size instead (same fallback as the main swap).
        if (bar && ids[1]) { try { swapIn(bar, j[ids[1]], '[data-h26-sticky]'); } catch (e) { window.location.assign(url.toString()); return; } }
        else if (bar) bar.removeAttribute('aria-busy');
        init(nm);
        try { window.OOH26PDP && window.OOH26PDP.init(); } catch (e) {}
        try { if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init(); } catch (e) {}
        var nb = $('[data-h26b-variant="' + id + '"]', nm);
        if (nb) nb.focus({ preventScroll: true });
      })
      .catch(function () { if (seq === vSeq) window.location.assign(url.toString()); });
  }

  function guardBusy(e) {
    var f = e.target;
    if (!f || !f.closest) return;
    var held = f.closest('.h26b[aria-busy="true"], [data-h26-sticky][aria-busy="true"]');
    if (held) { e.preventDefault(); e.stopImmediatePropagation(); }
  }
  if (!window.__h26bGuard) { window.__h26bGuard = 1; window.addEventListener('submit', guardBusy, true); }

  /* ---------- set picker: phone open / close (PICKER-SPEC.md) ---------- */
  function setPickOpen(pick, on) {
    if (!pick) return;
    pick.classList.toggle('is-open', !!on);
    var t = $('[data-h26b-pick-toggle]', pick);
    if (t) {
      t.setAttribute('aria-expanded', String(!!on));
      t.setAttribute('data-h26-state', on ? 'closed' : 'open'); // the state the NEXT click moves to
    }
  }

  /* ---------- clicks ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b;
    if ((b = t.closest('[data-h26b-pick-toggle]'))) { e.preventDefault(); var pk = b.closest('[data-h26b-pick]'); setPickOpen(pk, !(pk && pk.classList.contains('is-open'))); return; }
    if ((b = t.closest('[data-h26b-variant]'))) { e.preventDefault(); selectVariant(b); return; }
    if ((b = t.closest('[data-h26b-goto]'))) { e.preventDefault(); goTo(b.getAttribute('data-h26b-goto')); return; }
    if ((b = t.closest('[data-h26b-viewall]'))) {
      var car = b.closest('.h26b-car');
      var tr = car && $('[data-h26-track-car]', car);
      if (!tr) return;
      var on = !tr.classList.contains('is-all');
      tr.classList.toggle('is-all', on);
      car.classList.toggle('is-all', on);
      b.setAttribute('aria-pressed', String(on));
      b.textContent = on ? b.getAttribute('data-on') : b.getAttribute('data-off');
      setTimeout(function () { b.setAttribute('data-h26-state', on ? 'off' : 'on'); }, 0);
      if (!on) tr.scrollLeft = 0;
      return;
    }
    for (var k in KINDS) {
      if ((b = t.closest('[' + KINDS[k] + ']')) && b.tagName === 'BUTTON') { openPanel(k, b); return; }
    }
    if ((b = t.closest('[data-h26b-close]'))) {
      var p = b.closest('[data-h26b-panel]');
      if (p) closePanel(p.getAttribute('data-h26b-panel'), true);
      return;
    }
    if ((b = t.closest('[data-h26b-readall]'))) {
      var w = document.getElementById(b.getAttribute('aria-controls'));
      if (!w) return;
      var open = w.hidden;
      w.hidden = !open;
      b.setAttribute('aria-expanded', String(open));
      if (open) { setTimeout(function () { b.removeAttribute('data-h26-event'); }, 0); scrollToEl(w, 80); }
      return;
    }
    if ((b = t.closest('[data-h26b-jump]'))) {
      var kind = b.getAttribute('data-h26b-jump');
      var target = kind === 'reviews' ? document.getElementById('h26-reviews') : document.getElementById('h26b-' + kind);
      if (!target) return;
      e.preventDefault();
      if (kind === 'reviews') {
        var nat = document.getElementById('h26b-native');
        var ra = $('[data-h26b-readall]');
        if (nat && nat.hidden && !$('.h26b-rq', target) && ra) ra.click();
      }
      scrollToEl(target, 70);
    }
  }
  function onKey(e) {
    if (e.key !== 'Escape') return;
    var p = e.target && e.target.closest && e.target.closest('[data-h26b-panel]');
    if (p) { e.preventDefault(); closePanel(p.getAttribute('data-h26b-panel'), true); }
  }

  /* ---------- pre-order line after the market's cutoff (record: cutoff_at + after_cutoff_line) ---------- */
  // Review GPT-1-02 round 2: re-checked at the cutoff itself (timer, when it is under 24 days away) and whenever
  // the tab comes back or the page is restored, so a page left open across the cutoff switches too.
  var cutTimer = null;
  function initCutoff(root) {
    var next = Infinity;
    $$('[data-h26b-cutoff]', root || document).forEach(function (el) {
      var iso = (el.getAttribute('data-h26b-cutoff') || '').replace(/([+-]\d\d)(\d\d)$/, '$1:$2');
      var t = Date.parse(iso);
      if (!isFinite(t)) return;
      var past = Date.now() > t;
      var a = $('[data-h26b-after]', el), b = $('[data-h26b-before]', el);
      if (a && b) { a.hidden = !past; b.hidden = past; }
      if (!past && t < next) next = t;
    });
    if (cutTimer) { clearTimeout(cutTimer); cutTimer = null; }
    var wait = next - Date.now() + 1000;
    if (isFinite(next) && wait > 0 && wait < 2073600000) cutTimer = setTimeout(function () { initCutoff(document); }, wait);
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') { try { initCutoff(document); } catch (e) {} } });
  window.addEventListener('pageshow', function () { try { initCutoff(document); } catch (e) {} });

  function init(root) {
    try { initDots(root || document); } catch (e) { try { console.warn('[h26-bun] dots', e && e.message); } catch (x) {} }
    try { initCutoff(root || document); } catch (e) {}
    $$('[data-h26b-viewall]', root || document).forEach(function (b) { if (!b.hasAttribute('data-h26-state')) b.setAttribute('data-h26-state', 'on'); });
  }
  var bound = false;
  function boot() {
    init(document);
    if (!bound) { bound = true; document.addEventListener('click', onClick); document.addEventListener('keydown', onKey); }
  }
  window.OOH26BUN = { init: boot };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); try { window.OOH26PDP && window.OOH26PDP.init(); } catch (x) {} });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
